import React from 'react'

function SurveyPegawai() {
  return (
    <div>SurveyPegawai</div>
  )
}

export default SurveyPegawai